import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Download } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
export function Hero() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.querySelector('#compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex items-center min-h-[100svh] py-6 sm:py-12 overflow-hidden bg-[#0c3b42] text-white" data-id="element-86">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#7fd1c9 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-87"></div>

      <div className="container relative px-4 mx-auto max-w-6xl" data-id="element-88">
        <div className="flex flex-col items-center text-center" data-id="element-89">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="max-w-4xl mb-3 sm:mb-5 text-2xl sm:text-4xl font-black leading-tight tracking-tight md:text-5xl lg:text-6xl text-white" data-id="element-90">
            ORGANIZÁ TUS SESIONES CON DEPORTISTAS CON DISCAPACIDAD
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="mb-4 sm:mb-6 text-base sm:text-xl font-medium md:text-2xl text-[#7fd1c9]" data-id="element-91">
            KIT Psicología en Deporte Adaptado
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3
        }} className="w-[80%] max-w-[33rem] mb-4 sm:mb-7 cursor-pointer" onClick={scrollToPricing} data-id="element-92">
            <img src="https://cdn.magicpatterns.com/uploads/a8JkChFhnt9gAHEHWNb9cM/Diseno_sin_titulo_(39).png" alt="KIT Psicología en Deporte Adaptado - Sistema Clínico" className="w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-93" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="flex flex-col items-center w-full max-w-md" data-id="element-94">
            <CtaButton href="#compra" className="w-full mb-6 text-xl" data-id="element-95">
              SÍ, QUIERO EL KIT AHORA
            </CtaButton>

            <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-slate-300" data-id="element-96">
              <div className="flex items-center gap-1.5" data-id="element-97">
                <Zap className="w-4 h-4 text-[#7fd1c9]" data-id="element-98" />
                Acceso inmediato
              </div>
              <div className="flex items-center gap-1.5" data-id="element-99">
                <ShieldCheck className="w-4 h-4 text-[#7fd1c9]" data-id="element-100" />
                Pago único y seguro
              </div>
              <div className="flex items-center gap-1.5 w-full justify-center mt-2 text-[#7fd1c9] font-semibold" data-id="element-101">
                <Download className="w-4 h-4" data-id="element-102" />
                Descargás. Aplicás. Trabajás con más seguridad profesional.
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}